var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "setting-item" },
    [
      _c(
        "el-form-item",
        { attrs: { label: "组件高度(cm)" } },
        [
          _c("el-input-number", {
            staticClass: "setting-style_height",
            attrs: {
              "controls-position": "right",
              placeholder: "请输入高度",
              precision: _vm.precision,
              step: _vm.step,
              min: 0
            },
            model: {
              value: _vm.height,
              callback: function($$v) {
                _vm.height = _vm._n($$v)
              },
              expression: "height"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4384d164", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4384d164","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Setting/style_setting/SettingStyleHeight.vue
// module id = null
// module chunks = 